import Swal from "sweetalert2";
import axios from "axios";
import { ls } from "../variables";
import { encrypt } from "./cipher";


export const errorHandler = (err, navigate) => {
    if (err?.response?.data?.message == "Token not Found") {
        Swal.fire({
            title: "Session Timed Out!!",
            icon: "error",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    ls.removeAll();
                    navigate("/")
                }
            })
    }
    else if (err?.response?.data?.message == "Stay Signed in") {
        Swal.fire({
            title: "Session Expiration Warning",
            html: `<span style="font-weight: bold;">Your session is about to expire !</span>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#154063",
            cancelButtonColor: "#d33",
            cancelButtonText: "Log out",
            confirmButtonText: "Stay Logged in",
            customClass: {
               confirmButton: `auto-width`
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                let payload = ls.get("userInfo")
                let encryptedPayload = await encrypt(payload)
                axios
                    .post("/api/pms/createToken", {
                        payload: encryptedPayload
                    }, {
                        withCredentials: true
                    })
                    .then((res) => {
                        ls.set("isUserLoggedIn", true);
                        ls.set("authToken", res.data.authToken)
                        ls.set("refreshToken", res.data.refreshToken)
                    })
                    .catch((error) => {
                        console.log("error: ", error)
                    })
            }
            else {
                axios
                    .post("/api/pms/logout", {
                        withCredentials: true,
                        email: ls.get("email")
                    })
                    .then((res) => {
                        ls.removeAll();
                        navigate("/");
                    })
                    .catch((error) => {
                        console.log("error: ", error)
                    })
            }
        });
    }
    else if (err?.response?.data?.message == "Files with multiple extensions are not allowed"){
       Swal.fire({
            title: "An error has occured",
            text: err?.response?.data?.message,
            icon: "error",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
        });
    }
    else if (err?.response?.data?.message === "Too many requests, please try again after 5 mins.") {
        Swal.fire({
            title: "Oops!",
            text: err?.response?.data?.message,
            icon: "error",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
        });
    }
    else if (
        err?.response?.data?.message?.includes(
            "You are not currently authorized to upload content related to the following PMSs:"
        )
    ) {
        Swal.fire({
            title: "Oops!",
            text: err?.response?.data?.message,
            icon: "error",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
        });
    }
    else {
        Swal.fire({
            title: "An error has occured",
            text: "Something went wrong",
            icon: "error",
            confirmButtonColor: "#154063",
            confirmButtonText: "OK",
        });
    }
}